import { InnerContentWrap, useBreakpointV2 } from "@tm/ui-widgets";
import {
  FlexComp,
  FormattedText,
  H2Tag,
  H5Tag,
  TextNodeType,
} from "@tm/ui-widgets/components";
import { usePartnerContext } from "@tm/ui-widgets/hooks";
import { theme } from "@tm/utility/global";
import React from "react";
import ClaimStructure from "./ClaimStructure";
import { ClaimYourInsuranceStyle } from "./ClaimYourInsurance.style";

interface ClaimYourInsuranceProps {
  data?: {
    claimInfo: TextNodeType | string;
    claimIndex?: string;
  }[];
  title?: TextNodeType;
  info?: TextNodeType;
}

const ClaimYourInsurance = ({ data, title, info }: ClaimYourInsuranceProps) => {
  const device = useBreakpointV2();
  const context = usePartnerContext();
  return (
    <ClaimYourInsuranceStyle>
      <InnerContentWrap>
        {device == "lg" ? (
          <React.Fragment>
            <H2Tag>{title && <FormattedText value={title} />}</H2Tag>
            <H2Tag color={theme.greenText} margin="0 0 86px">
              {info && <FormattedText value={info} />}
            </H2Tag>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <H5Tag>{title && <FormattedText value={title} />}</H5Tag>
            <H5Tag color={theme.greenText5} margin="0 0 20px">
              {info && <FormattedText value={info} />}
            </H5Tag>
          </React.Fragment>
        )}
        <FlexComp gap={device == "lg" ? "100px" : "48px"} padding="0 0 20px 0">
          {data &&
            data.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <ClaimStructure
                    key={index}
                    claimInfo={item.claimInfo}
                    claimIndex={item.claimIndex}
                    showSpiral={index == data.length - 1}
                  />
                </React.Fragment>
              );
            })}
        </FlexComp>
      </InnerContentWrap>
    </ClaimYourInsuranceStyle>
  );
};

export default ClaimYourInsurance;
